import { auth } from './firebase'

async function getIdToken() {
  try {
    return await auth.currentUser?.getIdToken()
  } catch {
    return null
  }
}

export async function authedFetch(url, opts = {}) {
  const token = await getIdToken()
  const headers = { ...(opts.headers || {}) }
  if (token) headers['Authorization'] = `Bearer ${token}`
  return fetch(url, { ...opts, headers })
}
